export const formatNumber = (
  number: number,
  options: { fractionDigitsCount: number; culture: string } = {
    fractionDigitsCount: 2,
    culture: "en-UK",
  }
) => {
  return number.toLocaleString(options.culture, {
    maximumFractionDigits: options.fractionDigitsCount,
    minimumFractionDigits: options.fractionDigitsCount,
  });
};
